export default __webpack_public_path__ + "static/media/kit_labellisation_bronze.a3a54fcc.pdf";